var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCsvDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 23",
    id: "Layer_23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,31H8a3,3,0,0,1-3-3V22a3,3,0,0,1,3-3H21a3,3,0,0,1,3,3v6A3,3,0,0,1,21,31ZM8,21a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V22a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,16H15a1,1,0,0,1-.92-.62,1,1,0,0,1,.21-1.09l10-10a1,1,0,0,1,1.09-.21A1,1,0,0,1,26,5V15A1,1,0,0,1,25,16Zm-7.59-2H24V7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.78,27.29a2.49,2.49,0,0,1-2.55-2.55,2.48,2.48,0,0,1,2.55-2.55A2.61,2.61,0,0,1,12,22.5a2.32,2.32,0,0,1,.88.85l-.84.48a1.25,1.25,0,0,0-.51-.51,1.51,1.51,0,0,0-.76-.19,1.52,1.52,0,0,0-1.15.45,1.75,1.75,0,0,0,0,2.32,1.51,1.51,0,0,0,1.15.44,1.61,1.61,0,0,0,.76-.18,1.2,1.2,0,0,0,.51-.51l.84.48A2.32,2.32,0,0,1,12,27,2.44,2.44,0,0,1,10.78,27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.15,27.29A2.16,2.16,0,0,1,13.93,27a1.69,1.69,0,0,1-.7-.88l.82-.48a1.12,1.12,0,0,0,1.13.74,1,1,0,0,0,.6-.14.47.47,0,0,0,.19-.37.45.45,0,0,0-.24-.41,3.53,3.53,0,0,0-.82-.31,5.15,5.15,0,0,1-.56-.19,2.68,2.68,0,0,1-.45-.27,1.07,1.07,0,0,1-.35-.41,1.38,1.38,0,0,1-.12-.59,1.32,1.32,0,0,1,.47-1.06,1.76,1.76,0,0,1,1.14-.4,1.92,1.92,0,0,1,1.05.29,2,2,0,0,1,.7.81l-.81.47a1,1,0,0,0-.94-.63.73.73,0,0,0-.47.14.44.44,0,0,0-.17.35.45.45,0,0,0,.19.38,2.77,2.77,0,0,0,.74.31l.34.11.31.11a1.72,1.72,0,0,1,.31.16,1.51,1.51,0,0,1,.25.18.93.93,0,0,1,.21.25,1.42,1.42,0,0,1,.13.3,1.6,1.6,0,0,1,.05.39,1.31,1.31,0,0,1-.49,1.08A2,2,0,0,1,15.15,27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.63,27.19,17,22.29H18l1.2,3.77,1.19-3.77h1.05l-1.65,4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,43H33.43a1,1,0,0,1,0-2H40a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H25.41L16,15.41V20a1,1,0,0,1-2,0V15a1,1,0,0,1,.29-.71l10-10A1,1,0,0,1,25,4H40a3,3,0,0,1,3,3V40A3,3,0,0,1,40,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.57,43H17a3,3,0,0,1-3-3V30a1,1,0,0,1,2,0V40a1,1,0,0,0,1,1H30.57a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,45a1,1,0,0,1-.81-.42l-5-7A1,1,0,0,1,27,36h1V31a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v5h1a1,1,0,0,1,.81,1.58l-5,7A1,1,0,0,1,32,45Zm-3.06-7L32,42.28,35.06,38H35a1,1,0,0,1-1-1V32H30v5a1,1,0,0,1-1,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCsvDownload);
export default __webpack_public_path__ + "static/media/icon_csv_download.7111321f4ce65e0609f948651335e237.svg";
export { ForwardRef as ReactComponent };